import { render } from "./GlobalLanguageSelector.vue?vue&type=template&id=0a613f49&scoped=true"
import script from "./GlobalLanguageSelector.vue?vue&type=script&lang=js"
export * from "./GlobalLanguageSelector.vue?vue&type=script&lang=js"

import "./GlobalLanguageSelector.vue?vue&type=style&index=0&id=0a613f49&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a613f49"]])

export default __exports__